import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@getro/rombo';
import { Box } from 'rebass/styled-components';
import { FindemApplicationBoost } from './FindemApplicationBoost';
import { useAgentBoost } from '../hooks/useAgentBoost';
import { AgentBoost } from './AgentBoost';
import { FindemApplicationCalibration } from './FindemApplicationCalibration';
import { CalibrationSelection } from './CalibrationSelection';

export const LaunchApplicationBoostAgentModal = ({
  isOpen,
  onClose,
  job,
  openWidget,
  widgetView,
  isOpenWidgetLoading,
  setWidgetView,
  findemError,
}) => {
  const {
    handleStartAgent,
    handleStartCalibration,
    handleCalibrationToggle,
    companyName,
    jobTitle,
    userFullName,
    isCalibrationAgentSelected,
    totalCredits,
    isLoading,
    availableAgentCredits,
    modalVariant,
    collectionId,
    jobId,
  } = useAgentBoost({ job, openWidget, widgetView, setWidgetView });

  return (
    <>
      <Box
        sx={{
          '[data-testid="body"]': {
            p: ['boost', 'calibration'].includes(widgetView) ? 0 : '24px',
          },
          '[data-testid="close"]': {
            zIndex: 1000,
            top: '16px',
          },
        }}
      >
        <Modal isOpen={isOpen} onCancel={onClose} variant={modalVariant}>
          {widgetView === 'launch' && (
            <AgentBoost
              availableAgentCredits={availableAgentCredits}
              handleStartAgent={handleStartAgent}
              handleCalibrationToggle={handleCalibrationToggle}
              companyName={companyName}
              jobTitle={jobTitle}
              isCalibrationAgentSelected={isCalibrationAgentSelected}
              totalCredits={totalCredits}
              isLoading={isLoading}
            />
          )}
          {widgetView === 'calibration-selection' && (
            <CalibrationSelection
              jobTitle={jobTitle}
              userFullName={userFullName}
              onStartCalibration={handleStartCalibration}
              isLoading={isOpenWidgetLoading}
              job={job}
              collectionId={collectionId}
              jobId={jobId}
            />
          )}
          {widgetView === 'boost' && <FindemApplicationBoost isLoading={isOpenWidgetLoading} error={findemError} />}
          {widgetView === 'calibration' && (
            <FindemApplicationCalibration isLoading={isOpenWidgetLoading} error={findemError} />
          )}
        </Modal>
      </Box>
    </>
  );
};

LaunchApplicationBoostAgentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  job: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    organization: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  setWidgetView: PropTypes.func,
  openWidget: PropTypes.func.isRequired,
  isOpenWidgetLoading: PropTypes.bool.isRequired,
  widgetView: PropTypes.string,
  findemError: PropTypes.object,
};

LaunchApplicationBoostAgentModal.defaultProps = {
  job: null,
  setWidgetView: () => {},
  widgetView: 'launch',
  findemError: null,
};
